import { useEffect } from "react";

const OAuthCallback = () => {
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");

        if (code) {
            console.log("Código OAuth obtido:", code);
            window.opener.postMessage({ type: "oauth_code", code, raw: window.location.search }, "*");
            window.close();
        }
    }, []);

    return <p>Processando autenticação...</p>;
};

export default OAuthCallback;
